import React from 'react';
import { MapPin, CloudSnow } from 'lucide-react';
export function WeatherMap() {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-669">
      <div className="flex items-center justify-between mb-4" data-id="element-670">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-671">
          Carte météo régionale
        </h2>
        <div className="flex items-center space-x-2" data-id="element-672">
          <button className="px-3 py-1.5 text-sm font-medium bg-blue-100 text-blue-700 rounded-lg" data-id="element-673">
            Radar
          </button>
          <button className="px-3 py-1.5 text-sm font-medium bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200" data-id="element-674">
            Satellite
          </button>
        </div>
      </div>
      {/* Map Placeholder */}
      <div className="relative w-full h-96 bg-gradient-to-br from-blue-50 to-gray-100 rounded-lg overflow-hidden" data-id="element-675">
        {/* Simulated Weather Zones */}
        <div className="absolute inset-0" data-id="element-676">
          {/* Snow Zone 1 */}
          <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-blue-200 rounded-full opacity-60 blur-2xl" data-id="element-677"></div>
          {/* Snow Zone 2 */}
          <div className="absolute top-1/2 right-1/3 w-40 h-40 bg-indigo-200 rounded-full opacity-60 blur-2xl" data-id="element-678"></div>
          {/* Snow Zone 3 */}
          <div className="absolute bottom-1/4 left-1/2 w-36 h-36 bg-purple-200 rounded-full opacity-60 blur-2xl" data-id="element-679"></div>
          {/* Location Markers */}
          <div className="absolute top-1/3 left-1/3" data-id="element-680">
            <div className="relative" data-id="element-681">
              <MapPin className="w-6 h-6 text-blue-600" data-id="element-682" />
              <CloudSnow className="w-4 h-4 text-white absolute top-0 left-1" data-id="element-683" />
            </div>
          </div>
          <div className="absolute top-1/2 right-1/3" data-id="element-684">
            <div className="relative" data-id="element-685">
              <MapPin className="w-6 h-6 text-indigo-600" data-id="element-686" />
              <CloudSnow className="w-4 h-4 text-white absolute top-0 left-1" data-id="element-687" />
            </div>
          </div>
        </div>
        {/* Legend */}
        <div className="absolute bottom-4 left-4 bg-white rounded-lg shadow-lg p-3 space-y-2" data-id="element-688">
          <div className="flex items-center space-x-2" data-id="element-689">
            <div className="w-4 h-4 bg-blue-400 rounded" data-id="element-690"></div>
            <span className="text-xs text-gray-700" data-id="element-691">Neige légère (2-5 cm)</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-692">
            <div className="w-4 h-4 bg-indigo-500 rounded" data-id="element-693"></div>
            <span className="text-xs text-gray-700" data-id="element-694">
              Neige modérée (5-10 cm)
            </span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-695">
            <div className="w-4 h-4 bg-purple-600 rounded" data-id="element-696"></div>
            <span className="text-xs text-gray-700" data-id="element-697">Neige forte (10+ cm)</span>
          </div>
        </div>
      </div>
    </div>;
}